import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },
  contactContainer: {
    '& h6': {
      color: theme.palette.blue_300.main,
      fontWeight: 'bold',
      marginTop: 16
    }
  },
  contactWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  inputWrapper:{
    display: 'flex',
    alignItems: 'end',
    gap: '8px'
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'end',
    height: '100%',
    marginTop: '30px'
  },
  iconButton: {
    padding: 0,
    borderRadius: '8px',
    width: '37px',
    height: '37px',
    background: theme.palette.green_200.main,
    color: theme.palette.white_100.main,
    '&:hover': {
      background: theme.palette.blue_300.main
    },
    '&:disabled': {
      background:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_300.main,
      color:
        theme.palette.type === 'dark'
          ? theme.palette.dark_50.main
          : theme.palette.white_100.main
    }
  },
  
  paper: {
    width: '100%',
    boxShadow: 'none',
    background: 'transparent', // Garante que o fundo entre os itens seja o da modal
    marginTop: theme.spacing(2)
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
    '& .MuiListItem-root': {
      background:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main // Cor do "card" do contato
          : theme.palette.gray_100.main,
      padding: '0 16px !important', // Aumentei um pouco o padding interno
      marginBottom: '8px !important', // Espaço entre um card e outro
      borderRadius: '8px', // Deixa o visual mais moderno
      transition: 'all 0.2s',
      '&:hover': {
        background:
          theme.palette.type === 'dark'
            ? theme.palette.dark_300.main || '#333'
            : '#f5f5f5'
      }
    },
    // Remove a margem do último item para não sobrar espaço no final
    '& .MuiListItem-root:last-child': {
      marginBottom: '0 !important'
    }
  },
  listItemText: {
    display: 'flex',
    flexDirection: 'column'
  },
  contactName: {
    fontWeight: 'bold',
    fontSize: '1rem',
    color: theme.palette.blue_300.main
  },
  functionNameAndPhone: {
    fontSize: '0.875rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  iconButtonDelete: {
    padding: 0,
    borderRadius: '8px',
    width: '25px',
    height: '25px',
    background: 'transparent',
    color: theme.palette.red_100.main,
    '&:hover': {
      background: 'transparent',
      color: theme.palette.red_600.main
    }
  },
  
}))
